var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',_vm._b({attrs:{"value":_vm.normalizedValue,"options":_vm.tree,"props":_vm.props,"show-all-levels":false},on:{"input":_vm.onInput}},'el-cascader',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }